import React from "react";
import { InboxItemStatusEn } from "../../domain/InboxItem";
import { EventNote } from "@material-ui/icons";
import {
  formatUtcDate,
  standardDateFormats,
} from "@ofqual/portal-core/core/utils/dateUtils";
import { useListStyles } from "./listStyles";
import { ItemType } from "@ofqual/portal-core/core/hooks/useFieldLookups";
import { ListItem } from "@ofqual/portal-components/components/List/ListItem";
import {
  EventNotification,
  EventNotificationStatus,
} from "../../domain/EventNotification";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { UserType } from "../../redux/types";
import { authSelector } from "../../redux/selectors";

type EventNotificationItemProps = {
  item: EventNotification;
  navigate: (id: string) => void;
  orgLookups: ItemType;
};

export const EventNotificationItem: React.FC<EventNotificationItemProps> = ({
  item,
  navigate,
  orgLookups,
}) => {
  const classes = useListStyles();
  const { userType } = useAuth(authSelector);

  const getSentRecieved = (enLastResponseBy: UserType | undefined) => {
    return userType === enLastResponseBy ? "Sent" : "Received";
  };

  return (
    <ListItem
      onClick={() => navigate(item.id)}
      className={
        item.status === EventNotificationStatus.Closed
          ? classes.disabled
          : classes.active
      }
      dataTest="row"
      Icon={EventNote}
      primaryText={item.title || ""}
      secondaryDetails={[
        { heading: "Created by", value: item.createdByDisplayName },
        {
          heading: "Created date",
          value: formatUtcDate(item.createdDate, standardDateFormats.DATE_TIME),
        },
        {
          heading: "Last response date",
          value: formatUtcDate(
            item.lastResponseDate,
            standardDateFormats.DATE_TIME
          ),
        },
        { heading: "AO", value: item.orgId ? orgLookups[item.orgId] : null },
        { heading: "AO reference", value: item.aoReference },
      ]}
      chipTexts={[
        getSentRecieved(item.lastResponseByUserType),
        `Status: ${InboxItemStatusEn[item.status]}`,
      ]}
    />
  );
};
